module.exports = __webpack_public_path__ + "static/media/attendancedash.aa09560e.png";